import Cards from './ComponentUI/Cards'
import Invoiced from '@assets/dashboard/invoiced.svg'
import Vehicles from '@assets/dashboard/vehicles.svg'
import Dispatched from '@assets/dashboard/dispatched.svg'

import SubmitSupplyQuote from '@assets/dashboard/supply-quote-pending.svg'
import AddDispatchPlan from '@assets/dashboard/add-dispatch-plan.svg'
import SubmitSupplierKyc from '@assets/dashboard/submit-supplier-kyc.svg'
import DelayedOrders from '@assets/dashboard/supply-delayed-orders.svg'
import Deeplinks from './ComponentUI/Deeplinks'
import Spo from './ComponentUI/Supply/Spo'
import EnquiryVsOrder from './ComponentUI/Supply/EnquiryVsOrder'
import DispatchPlan from './ComponentUI/Supply/DispatchPlan'
import OrganicQuoteReceived from './ComponentUI/Supply/OrganicQuoteReceived'
import NewEnquiryQuotes from './ComponentUI/Supply/NewEnquiryQuotes'
import { displayAmount } from '@utils'
import { ContainerWrapper, Wapper } from './SalesDashboard'
import { MB_ROLES, strings } from '@constants'
import { paths } from '@routes'
import EnquiryRevenue2 from './ComponentUI/Supply/EnquiryRevenue2'
import BlacklistedOrg from './ComponentUI/Supply/BlacklistedOrg'

const DeeplinksData = [
	{ title: strings(['submit', 'supply', 'quote']), icon: SubmitSupplyQuote, href: paths.admin_manage_enquiry_active, actionButton: false },
	{
		title: strings(['add', 'dispatch', 'plan']),
		icon: AddDispatchPlan,
		href: `${paths.admin_dispatch_plan_active}?add_plan=true`,
		actionButton: false,
	},
	{ title: strings(['submit', 'supplier', 'kyc']), icon: SubmitSupplierKyc, href: '#', actionButton: true },
	{ title: strings('delayed', 'orders'), icon: DelayedOrders, href: paths.admin_manage_enquiry_orders_order_book, actionButton: false },
]

const SupplyDashboard = ({ dashboardType, data }) => {
	const cards = [
		{ id: 1, label: 'Yesterday vehicles dispatched', value: data?.yesterdays_bills_amount_and_count?.unit || 0, icon: Vehicles, unit: '' },
		{ id: 2, label: 'Yesterday qt. dispatched', value: data?.yesterday_bills_dispatched || 0, icon: Dispatched, unit: 'MT' },
		{
			id: 3,
			label: 'Yesterday billed',
			value: displayAmount(data?.yesterdays_bills_amount_and_count?.amount || 0),
			icon: Invoiced,
			unit: 'Cr',
		},
	]

	return (
		<>
			<ContainerWrapper>
				<Wapper>
					{cards?.map((item, index) => (
						<Cards key={index} icon={item?.icon} label={item?.label} value={item?.value} unit={item?.unit} />
					))}
				</Wapper>
				{/* <Wapper>
				<EnquiryRevenue
					Quoted={data?.total_quoted_enquiry_count ?? '-'}
					TotalEnquiries={data?.total_assigned_enquiry_count ?? '-'}
					OrganicQuotesConverted={data?.organic_quotes_converted_count}
					NewSuppliersOnboarded={data?.onboarded_org_count}
					QuoteSubmitted={data?.total_quoted_amount}
					OrderConverted={data?.total_ordered_weight}
					OpenOrderBook={data?.pending_order}
					Serviced={data?.total_serviced_weight}
					BilledInvoiced={data?.total_purchase_business?.amount}
					SupplyMargin={data?.supply_margin}
					AdvtoSupplier={data?.adv_to_supplier}
				/>
			</Wapper> */}
				<Wapper>
					<EnquiryRevenue2
						dashboardType={dashboardType}
						Quoted={data?.total_quoted_enquiry_count ?? '-'}
						TotalEnquiries={data?.total_assigned_enquiry_count ?? '-'}
						OrganicQuotesConverted={data?.organic_quotes_converted_count}
						NewSuppliersOnboarded={data?.onboarded_org_count}
						// QuoteSubmitted={data?.total_quoted_amount}
						OrderConvert={data?.total_ordered_weight}
						OpenOrderBook={data?.pending_order}
						Serviced={data?.total_serviced_weight}
						BilledInvoiced={data?.total_purchase_business?.amount}
						SupplyMargin={data?.supply_margin}
						AdvtoSupplier={data?.adv_to_supplier}
						QuotedWeight={data?.total_quoted_weight}
						OrderConverted={data?.ordered_weight}
						ServicedWeight={data?.serviced_weight}
						OpenOrderBooks={data?.total_pending_order}
						EnquiryWeight={data?.total_assigned_weight}
						DebitNote={data?.total_purchase_business?.credit_amount}
						AverageQuoteCount={data?.avg_quote_count}
					/>
				</Wapper>
				<Wapper>
					<div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
						<Deeplinks DeeplinksData={DeeplinksData} ImageWidth={'25%'} type={MB_ROLES.SUPPLY} />
						<EnquiryVsOrder OrderConvertedData={data?.assigned_enquiries} TotalOrderData={data?.total_orders} />
					</div>
					<Spo
						RunningData={data?.open_purchase_order_running}
						DelayedData={data?.open_purchase_order_delayed}
						DelayedCount={data?.total_delayed_purchase_count ?? 0}
						RunningCount={data?.total_running_purchase_count ?? 0}
						OpenPurchaseCount={data?.total_open_purchase_count ?? 0}
					/>
				</Wapper>
				<Wapper>
					<DispatchPlan
						YesterdayData={data?.dispatch_plan_yesterday?.content}
						TodayData={data?.dispatch_plan_today?.content}
						WeeklyData={data?.dispatch_plan_weekly?.content}
					/>
				</Wapper>
				<Wapper>
					<OrganicQuoteReceived organicQuote={data?.organic_quote_received} />
					<NewEnquiryQuotes enquiries={data?.enquiries} />
				</Wapper>
				<Wapper>
					<BlacklistedOrg data={data?.blacklisted_supplier_list} />
				</Wapper>
			</ContainerWrapper>
		</>
	)
}

export default SupplyDashboard
